/** 当前文件仅用于在浏览器环境中唤起APP页面，未下载APP会引导到APP Store,不用于在APP内打开页面，判断环境放到业务层中 */

import {
  AppSource,
  AppUrlType,
  AppRouterName,
  ITrackProductInfoAppParams,
} from "@/shared";
import { YooFindsCallApp } from "./base-call-app";
import { base64Encode } from "./encode";
import { getUri } from "./url";

/**
 * 唤起 APP - 目标 h5 页面
 * @param target_url 目标 h5 页面
 * @param callback 回调函数
 * @param deepLinkUrl 深度链接 URL
 */
export async function launchAppH5(
  targetUrl: string,
  callback?: (url: string) => void,
  deepLinkUrl?: string
) {
  const path = getUri(AppUrlType.H5, {
    target_url: base64Encode(targetUrl),
  });
  YooFindsCallApp.callOpenApp(path, callback, deepLinkUrl);
}

/**
 * 唤起APP - app首页
 * @param deepLinkUrl 深度链接URL
 * @param callback 回调函数
 */
export async function launchAppHome(
  callback?: (url: string) => void,
  deepLinkUrl?: string
) {
  const path = `${AppUrlType.App}${AppRouterName.Home}`;
  YooFindsCallApp.callOpenApp(path, callback, deepLinkUrl);
}

/**
 * 唤起APP - app钱包页面
 * @param deepLinkUrl 深度链接URL
 * @param callback 回调函数
 */
export async function launchAppWallet(
  callback?: (url: string) => void,
  deepLinkUrl?: string
) {
  const path = `${AppUrlType.App}${AppRouterName.Wallet}`;
  YooFindsCallApp.callOpenApp(path, callback, deepLinkUrl);
}

/**
 * 唤起APP - h5广告任务详情
 * @param taskId 广告任务ID
 * @param deepLinkUrl 深度链接URL
 * @param callback 回调函数
 */
export async function launchAppAdTaskDetail(
  taskId: string,
  callback?: (url: string) => void,
  source?: AppSource,
  deepLinkUrl?: string
) {
  const path = getUri(
    `${AppUrlType.App}${AppRouterName.AdTaskDetailInfoPage}`,
    {
      ad_task_id: taskId,
      source,
    }
  );
  YooFindsCallApp.callOpenApp(path, callback, deepLinkUrl);
}

/**
 * 唤起APP - app广告任务进度详情
 * @param taskId 广告任务ID
 * @param callback 回调函数
 * @param deepLinkUrl 深度链接URL
 */
export async function launchAppAdTaskOrderDetail(
  taskOrderId: string,
  callback?: (url: string) => void,
  deepLinkUrl?: string
) {
  const path = getUri(`${AppUrlType.App}${AppRouterName.AdTaskDetailPage}`, {
    task_order_id: taskOrderId,
  });
  YooFindsCallApp.callOpenApp(path, callback, deepLinkUrl);
}

/**
 * 唤起APP - app样品详情
 * @param orderId 样品订单ID
 * @param callback 回调函数
 * @param deepLinkUrl 深度链接URL
 */
export async function launchAppSampleDetail(
  orderId: string,
  callback?: (url: string) => void,
  deepLinkUrl?: string
) {
  const path = `sampledetail/${orderId}`;
  YooFindsCallApp.callOpenApp(path, callback, deepLinkUrl);
}

/**
 * 唤起APP - app商品详情
 * @param productHashId 商品Hash ID
 * @param appParams 商品参数
 * @param callback 回调函数
 * @param deepLinkUrl 深度链接URL
 */
export async function launchAppProductDetail(
  productHashId: string,
  appParams?: ITrackProductInfoAppParams,
  callback?: (url: string) => void,
  deepLinkUrl?: string
) {
  const path = appParams
    ? `products/${productHashId}?source_params=${base64Encode(
        JSON.stringify(appParams)
      )}`
    : `products/${productHashId}?source_params=`;
  YooFindsCallApp.callOpenApp(path, callback, deepLinkUrl);
}
